import { useTranslations } from '@vocab/react';
import {
  Toggle,
  Alert,
  Heading,
  Text,
  Stack,
  Columns,
  Column,
  Disclosure,
  Actions,
  Button,
} from 'braid-design-system';

import { APPROACHABILITY } from 'src/components/Router';
import { Link } from 'src/components/Router/Link';
import { READ } from 'src/consts';
import { useAppConfig } from 'src/modules/appConfig';
import { useFocus } from 'src/modules/hooks/useFocus';
import { NEXT_ROLE_SECTION_CONTENT_SPACING } from 'src/styles';

import { useApproachability, useUpdateApproachability } from '../data';

import translations from './.vocab';

export const EditApproachability = () => {
  const { t } = useTranslations(translations);
  const { brand } = useAppConfig();
  const approachabilityRef = useFocus<HTMLInputElement>({
    card: APPROACHABILITY,
    fieldName: 'approachability',
  });
  const { approachable: currentApproachability } = useApproachability();

  const [updateApproachability] = useUpdateApproachability();
  const onChange = (approachable: boolean) => {
    updateApproachability({ approachability: { approachable } });
  };

  return (
    <Stack space={NEXT_ROLE_SECTION_CONTENT_SPACING}>
      <Columns space="small" alignY="center">
        <Column width="content">
          <Heading level="4" component="h2">
            {t('Show my approachability')}
          </Heading>
        </Column>
        <Column>
          <Toggle
            label=""
            align="right"
            id="approachable-toggle"
            on={currentApproachability}
            onChange={onChange}
            ref={approachabilityRef}
          />
        </Column>
      </Columns>
      {!currentApproachability && (
        <Alert tone="promote">
          <Text>
            {t(
              'Youre much more likely to be contacted for new opportunities...',
            )}
          </Text>
        </Alert>
      )}
      <Text>
        {t('Should we show employers your approachability status...', {
          brand,
        })}{' '}
        <Disclosure
          id="approachability"
          weight="weak"
          space="small"
          expandLabel={t('More')}
          collapseLabel={t('Less')}
        >
          {t(
            'Employers looking at a list of suitable profiles will see a label...',
            { brand },
          )}
        </Disclosure>
      </Text>
      <Actions>
        <Link
          to={APPROACHABILITY}
          mode={READ}
          component={Button}
          tone="formAccent"
          data={{ automation: 'approachability-done' }}
        >
          {t('Done')}
        </Link>
      </Actions>
    </Stack>
  );
};
